<h1 class="page-title mb-5">الأحداث</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div class="search-filter-container mb-5">
          <div class="row align-items-start gy-3">
            <div class="col-md-12">
              <div class="row align-items-end p-4" style="background-color: #f2f2f2; border-radius: 4px">
                <div class="col-lg-3 col-md-6">
                  <label class="form-label fw-bold">الفئة</label>
                  <select class="form-select custom-input">
                    <option>الكل</option>
                  </select>
                </div>
                <div class="col-lg-3 col-md-6">
                  <label class="form-label fw-bold">من</label>
                  <div class="input-group">
                    <input type="text" class="form-control custom-input" placeholder="" />
                    <span class="input-group-text bg-custom-green text-white"><i
                        class="material-icons">calendar_today</i></span>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <label class="form-label fw-bold">إلى</label>
                  <div class="input-group">
                    <input type="text" class="form-control custom-input" placeholder="" />
                    <span class="input-group-text bg-custom-green text-white"><i
                        class="material-icons">calendar_today</i></span>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 d-flex gap-2">
                  <button class="btn btn-refresh">
                    <i class="material-icons">refresh</i>
                  </button>
                  <button class="btn btn-search flex-grow-1">بحث</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- News List -->
        <div class="news-list-container">
          <div class="news-card mb-4" *ngFor="let news of newsList">
            <div class="row g-0">
              <div class="col-md-8 order-2 order-md-2">
                <div class="news-content">
                  <div class="news-date mb-2">{{ news.date }}</div>
                  <h3 class="news-title mb-3">{{ news.title }}</h3>
                  <p class="news-desc mb-4">{{ news.description }}</p>
                  <button class="btn-read-more" [routerLink]="['/medianews', news.id]">اقرأ المزيد</button>
                </div>
              </div>
              <div class="col-md-4 order-1 order-md-1">
                <div class="news-img-wrapper">
                  <img [src]="news.image" class="news-img" alt="{{ news.title }}"
                    onerror="this.src='assets/images/placeholder.jpg'" />
                  <div class="green-decoration"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <app-fix-media></app-fix-media>
      </div>
    </div>
  </div>
</div>